module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 421
// module chunks = 0